module.exports = __webpack_public_path__ + "static/media/uhill-logo.bb1ba83b.jpg";